export default function EventFlyersEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
       {/*Start File*/}
      <tr>
        <td>
          <a href="/docs/flyers/flyer-2026-MemorialDayCommunityGathering-May25.pdf" alt="5/25/26 Summerseat Memorial Day Community Gathering flyer" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 5/25/2026 - Memorial Day Community Gathering
          </a>
        </td>
        <td>5/12/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="/docs/flyers/flyer-2026-SummerseatSpeakers-May24.pdf" alt="5/24/26 Summerseat Historical Speakers flyer" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 5/24/2026 - Summerseat 250th Celebration: Historical Speakers Betsy Ross &amp; Geroge Washington
          </a>
        </td>
        <td>5/12/2026</td>
      </tr>
      {/*End File*/}
         {/*Start File*/}
      <tr>
        <td>
          <a href="/docs/flyers/flyer-2026-SummerseatLectures-May23.pdf" alt="5/23/26 Summerseat Lectures flyer" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 5/23/2026 - Summerseat 250th Celebration: Joel Farkas Lectures
          </a>
        </td>
        <td>5/12/2026</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
      <tr>
        <td>
          <a href="/docs/flyers/flyer-2026-BridgeStCarShow-May16.pdf" alt="5/16/26 Bridge St. Vintage Car Show" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 5/16/2026 - Bridge St. Vintage Car Show
          </a>
        </td>
        <td>5/12/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="/docs/flyers/flyer-2026-RockAndRollFestival250-May16.pdf" alt="5/16/26 2nd Annual Rock & Roll Festival 250" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 5/16/2026 - 2nd Annual Rock &amp; Roll Festival 250
          </a>
        </td>
        <td>5/4/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="/docs/flyers/flyer-2026-Ivins-Run-Through-History.pdf" alt="6/13/26 Ivins Outreach Inaugural Run Through History " target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 6/13/2026 - Ivins Outreach Inaugural Run Through History
          </a>
        </td>
        <td>4/5/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2026-Easter-Egg-Hunt.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 4/4/2026 - Easter Egg Hunt
          </a>
        </td>
        <td>3/19/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2026-Summerseat-Kick-Off-Event.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 1/31/2026 - Kick-Off Event Semiquincentennial Celebration @ Summerseat
          </a>
        </td>
        <td>1/21/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-historic-holiday-tour.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 12/13/2025 - Historic Holiday Tour
          </a>
        </td>
        <td>11/25/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-summerseat remembers.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 12/6/2025 - Summerseat Remebers Holiday Event
          </a>
        </td>
        <td>11/25/2025</td>
      </tr>
      {/*End File*/}

      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-oct-trunk-or-treat.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 10/17/2025 - Trunk Or Treat At Grandview Elementary
          </a>
        </td>
        <td>10/8/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-drug-take-back-october.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 9/25/2025 - Medication Take Back Day
          </a>
        </td>
        <td>9/9/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-Morrisville-Riverfront-Preserve-Events.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Multi Day - Morrisville Riverfront Preserve Events
          </a>
        </td>
        <td>9/3/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-dog-park-pool-party-sept.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 9/21/2025 - Dog Park Pool Party
          </a>
        </td>
        <td>9/3/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-national-night-out.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 8/5/2025 - National Night Out
          </a>
        </td>
        <td>7/24/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-movie-in-the-park-july.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 7/18/2025 - Movie In The Park
          </a>
        </td>
        <td>7/15/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-dog-park-pool-party-july.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 7/20/2025 - Dog Park Pool Party
          </a>
        </td>
        <td>7/15/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-may-summerseat-misery-of-war.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 5/18/2025 - Summerseat Special Presentation: Miseries of the Revolutionary War
          </a>
        </td>
        <td>4/29/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-apr-egg-hunt.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 4/19/2025 - Easter Egg Hunt
          </a>
        </td>
        <td>4/3/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2025-feb-summerseat-tea.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2/22/2025 - Tea with Martha &amp; Washington at Summerseat Mansion
          </a>
        </td>
        <td>2/10/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2024-winterfest-event.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Winterfest 2024 Event Details
          </a>
        </td>
        <td>11/27/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/flyers/flyer-2024-winterfest-parade.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Winterfest 2024 Parade
          </a>
        </td>
        <td>11/1/2024</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
